import * as React from "react";

import type { AuthState, LoginPayload, RegisterPayload } from "@/types";

export type AuthContextValue = AuthState & {
  isMasked: boolean;
  login: (payload: LoginPayload) => Promise<void>;
  register: (payload: RegisterPayload) => Promise<void>;
  logout: () => Promise<void>;
  selectCustomer: (customerId: number) => Promise<void>;
  switchCustomer: () => Promise<void>;
};

export const AuthContext = React.createContext<AuthContextValue | null>(null);
